import { apiService } from "../../app.service";

export const advertApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    fetchAdvert: builder.query({
      query: () => ({
        url: "/advert",
      }),
      providesTags: ["adverts"],
    }),
    fetchAdvertById: builder.query({
      query: (id) => ({
        url: `/advert/${id}`,
      }),
      providesTags: (result) =>
        result ? [{ type: "advert", id: result._id }] : [],
    }),
    createAdvert: builder.mutation({
      query: (data) => ({
        url: "/advert",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["adverts"],
    }),
    updateAdvert: builder.mutation({
      query: ({ id, data }) => ({
        url: `/advert/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "advert", id },
        "adverts",
      ],
    }),
    deleteAdvert: builder.mutation({
      query: (id) => ({
        url: "/advert/" + id,
        method: "DELETE",
      }),
      invalidatesTags: ["adverts"],
    }),
  }),
});

export const {
  useFetchAdvertQuery,
  useFetchAdvertByIdQuery,
  useCreateAdvertMutation,
  useUpdateAdvertMutation,
  useDeleteAdvertMutation,
} = advertApi;
